module.exports = __webpack_public_path__ + "img/141.3.a7c9a5ea.png";